import React, { useState, useEffect } from 'react';

import { accountService } from '../_services';
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";

function Home() {
  const [todayCount, setTodayCount] = useState(0);
  const [futureCount, setFutureCount] = useState(0);
  const [pastCount, setPastCount] = useState(0);
  const { t } = useTranslation();
  const displayName = accountService.configValue['displayName'];



  useEffect(() => {
    console.log("HOME MOUNTED!");
      const sub = accountService.futureReservationCount.subscribe(x => setFutureCount(x));
      const sub2 = accountService.pastReservationCount.subscribe(x => setPastCount(x));
      const sub3 = accountService.todayReservationCount.subscribe(x => setTodayCount(x));
    return () => {
      console.log("HOME UNMOUNTED!");
      sub.unsubscribe();
      sub2.unsubscribe();
      sub3.unsubscribe();
    }
  }, []);

  return (
    <div className="card m-3">
      <h1 className="card-header">Tiburon Lockers</h1>

      <Link className="home-btn home-rent-btn" to="/new-reservation" >
        <h3>{t('Rent a Locker Now')}</h3>
      </Link>

      {accountService.configValue['useFutureReservationButton'] === 'true' && (
        <>
            <Link className="home-btn home-rent-btn" to="/future-reservation">
                <h3>{t('Reserve a locker in the future')}</h3>
            </Link>
        </>
      )}
      <br />

      {(todayCount > 0) &&
        <>
          <Link className="home-btn home-lockers-btn" to="/reservations/active">
          <h3>{t('Lockers')}</h3>
          </Link>
          <br />
        </>
      }
      {(futureCount > 0) &&
        <>
          <Link className="home-btn home-rsv-btn" to="/reservations/all">
          <h3>{t('Reservations')}</h3>
          </Link>
          <br />
        </>
      }
      {(pastCount > 0) &&
       <>
              <Link className="home-btn home-hist-btn" to="/reservations/past">
              <h3>{t('Order History')}</h3>
              </Link>
              <br />
       </>
      }
      <div className="row">

        <Link className="home-btn home-edit-btn" to="/profile">
          <h5>{t('Account')}</h5>
        </Link>

        <Link className="home-btn home-help-btn" to="/contact">
          <h5>{t('Help')}</h5>
        </Link>

        <Link onClick={accountService.logout} to="/" className="home-btn home-logout-btn home-btn-last">
          <h5>{t('Logout')}</h5>
        </Link>

      </div>
    </div>

  );
}

export { Home };